import { defineComponent as n, createElementBlock as o, openBlock as t, createElementVNode as r, createCommentVNode as a, toDisplayString as s, createVNode as l, unref as p } from "vue";
import { ScalarMarkdown as c } from "@scalar/components";
const i = { class: "property-enum-value" }, m = { class: "property-enum-value-content" }, u = { class: "property-enum-value-label" }, d = {
  key: 0,
  class: "property-enum-value-description"
}, h = /* @__PURE__ */ n({
  __name: "SchemaEnumPropertyItem",
  props: {
    label: {},
    description: {}
  },
  setup(_) {
    return (e, v) => (t(), o("li", i, [
      r("div", m, [
        r("span", u, s(e.label), 1),
        e.description ? (t(), o("span", d, [
          l(p(c), { value: e.description }, null, 8, ["value"])
        ])) : a("", !0)
      ])
    ]));
  }
});
export {
  h as default
};
